import React, { useState, useEffect } from 'react';
import './CardComponent.css';
import jwtDecode from 'jwt-decode';
import { useParams } from 'react-router-dom';
import Swal from 'sweetalert2'; // Import SweetAlert2
import axios from 'axios';

const Applications = () => {
  const [applications, setApplications] = useState([]);
  const { id } = useParams();
  const [userExist, setUserExist] = useState(false); // State to track if the user exists or not


  useEffect(() => {
    const fetchApplicationsByCategory = async () => {
      try {
        const response = await axios.get(`https://stage-cni-backend.vercel.app/getApplicationsByCategorie/${id}`);
        setApplications(response.data.applications);
      } catch (error) {
        console.error('Failed to fetch applications:', error);
      }
    };

    fetchApplicationsByCategory();

    // Check for JWT token in localStorage or cookie
    const token = localStorage.getItem('jwtToken');
    if (token) {
      setUserExist(true); // Set userExist to true if token is found
    } else {
      setUserExist(false); // Set userExist to false if token is not found
    }
  }, [id]);

  const requestQuotation = async (idApplication) => {
    try {
      const token = localStorage.getItem('jwtToken');
      const decodedToken = jwtDecode(token);
      const idUser = decodedToken.id;
      const response = await axios.post(`https://stage-cni-backend.vercel.app/sendDevisByApplicationId/${idApplication}/${idUser}`);
      
      console.log(response.data.message); // Log success message
  
      // Show success alert using SweetAlert2
      Swal.fire({
        icon: 'success',
        title: 'Quotation Requested Successfully!',
        text: 'We have successfully sent your quotation request.',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Great!',
      });
  
    } catch (error) {
      console.error('Failed to request quotation:', error);
      // Handle error, show error message to the user, etc.
    }
  };

  return (
    <div className="container" style={{ marginTop: '50px', marginBottom: '50px' }}>
      <div className="row">
        {applications.map((app) => (
          <div key={app._id} className="col-md-3">
            <div className="card-sl mt-3">
              <div className="card-image">
                <img src={app.image.url} alt={app.name} />
              </div>
              <div className="card-heading">{app.nom}</div>
              <div className="card-text">{app.description}</div>
              <div className="card-text">${app.prix}</div>
              <button
                className="card-button"
                style={{ fontWeight: 'bold' }}
                disabled={!userExist}
                onClick={() => requestQuotation(app._id)}>
                Request Quotation
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Applications;
